module.exports = __webpack_public_path__ + "02_baby.493c7105.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer5/02_baby.png
// module id = cOM1
// module chunks = 0